<template>
  <EmdPanel>
    <EmdPanelSection
      :title="$t('recipients.create.automatic_anticipation_settings.title')"
    >
      <EmdFormGroup
        :label="
          $t('recipients.create.automatic_anticipation_settings.antecipation')
        "
      >
        <EmdSwitcher
          :label="
            automatic_anticipation_settings.enabled
              ? $t('recipients.create.active')
              : $t('recipients.create.inactive')
          "
          id="automatic_anticipation_settings"
          v-model="automatic_anticipation_settings.enabled"
        />
      </EmdFormGroup>

      <EmdFormGroup>
        <label
          class="emd-label"
          :class="{ _required: automatic_anticipation_settings.enabled }"
        >
          {{ $t('recipients.create.automatic_anticipation_settings.type') }}

          <emd-tippy
            data-template="prepayment_type_info"
            id="prepayment_type_info"
            class="eu-ml_1"
            :type="'html'"
            position="bottom"
          >
            <i
              :class="'emd-text _color_subtle'"
              class="uil uil-info-circle"
            />
            <emd-tippy-template-HTML id="prepayment_type_info">
              <div style="text-transform: initial; letter-spacing: 0">
                <p>
                  {{
                    $t('recipients.create.prepayment_info', {
                      url: prepaymentLink
                    })
                  }}
                </p>
              </div>
            </emd-tippy-template-HTML>
          </emd-tippy>
        </label>

        <div class="eu-mt_2">
          <EmdRadio
            :label="
              $t(
                'recipients.create.automatic_anticipation_settings.type_volume'
              )
            "
            id="antecipation_type_volume"
            name="automatic_anticipation_settings"
            value="full"
            v-model="automatic_anticipation_settings.type"
            class="eu-mr_4 eu-mb_2"
          />

          <EmdRadio
            :label="
              $t('recipients.create.automatic_anticipation_settings.type_d+x')
            "
            id="antecipation_type_d+x"
            name="automatic_anticipation_settings"
            value="1025"
            v-model="automatic_anticipation_settings.type"
            class="eu-mr_4 eu-mb_2"
          />
        </div>
      </EmdFormGroup>

      <EmdFormGroup
        v-if="
          automatic_anticipation_settings.type &&
          automatic_anticipation_settings.type === 'full'
        "
        :label="
          $t(
            'recipients.create.automatic_anticipation_settings.volume_percentage'
          )
        "
        :required="automatic_anticipation_settings.enabled"
        :feedbacks="
          feedbacks(
            vuelidate.automatic_anticipation_settings.volume_percentage,
            automatic_anticipation_settings.enabled
          )
        "
        :state="
          getState(
            vuelidate.automatic_anticipation_settings.volume_percentage,
            automatic_anticipation_settings.enabled
          )
        "
      >
        <EmdInput
          @input="
            vuelidate.automatic_anticipation_settings.volume_percentage.$touch
          "
          v-model="automatic_anticipation_settings.volume_percentage"
          name="volume_percentage"
          type="number"
        />
      </EmdFormGroup>

      <EmdFormGroup
        v-if="
          automatic_anticipation_settings.type &&
          automatic_anticipation_settings.type === '1025'
        "
        :label="$t('recipients.create.automatic_anticipation_settings.delay')"
        :required="automatic_anticipation_settings.enabled"
      >
        <EmdInput
          v-model="automatic_anticipation_settings.delay"
          name="delay"
          type="number"
        />
      </EmdFormGroup>
    </EmdPanelSection>
  </EmdPanel>
</template>

<script>
import {
  EmdPanel,
  EmdPanelSection,
  EmdFormGroup,
  EmdInput,
  EmdSwitcher,
  EmdRadio,
  EmdTippy,
  EmdTippyTemplateHTML
} from 'emerald-vue/src/components'

import { getState, feedbacks } from '@/utils/form.utils'

export default {
  name: 'PrepaymentSettings',
  components: {
    EmdPanel,
    EmdPanelSection,
    EmdFormGroup,
    EmdInput,
    EmdSwitcher,
    EmdRadio,
    EmdTippy,
    EmdTippyTemplateHTML
  },
  data: () => ({
    getState,
    feedbacks
  }),
  props: {
    automatic_anticipation_settings: {
      type: Object,
      required: true
    },
    vuelidate: {
      type: Object,
      required: true
    }
  },
  computed: {
    tags () {
      return {
        mundipagg: '#informações-de-antecipação-automática',
        pagarme: '#informações-de-antecipação-automática-1'
      }
    },
    prepaymentLink () {
      return `${process.env.VUE_APP_URL_DOCUMENTATION}reference${this.tags.pagarme}`
    }
  }
}
</script>
